// 竞标：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 竞标页面
export const page = Object.freeze({
  "bidPage.filterConditions": "Filters",
  "bidPage.allBids": "All bids",
  "bidPage.clear": "Clear",
  "bidPage.filter": "Filter",
  "bidPage.allFilters": "All filters",
  "bidPage.closeFilters": "Close filters",
  "bidPage.productBrand": "Brand",
  "bidPage.goodsLocation": "Stock location",
  "bidPage.goodsCondition": "Goods condition",
  "bidPage.allCategories": "All categories",
  "bidPage.allBrands": "All brands",
  "bidPage.allLocations": "All locations",
  "bidPage.allConditions": "All conditions",
  "bidPage.reset": "Reset",
  "bidPage.done": "Done",
  "bidPage.statistics": "Statistics",
  "bidPage.manage": "Manage",
  "bidPage.post": "Post",
  "bidPage.bidding": "Bidding",
  "bidPage.bidStatistics": "Closed-bid statistics",
  "bidPage.partNumbers": "Part numbers",
  "bidPage.bidUsers": "Bidders",
  "bidPage.table": "List",
  "bidPage.loading": "Loading...",
  "bidPage.empty": "No matching listings",
  "bidPage.trend": "Price trend",
  "bidPage.trendFor": "Price trend for {partNumber}",
  "bidPage.currentPrice": "Current price",
  "bidPage.lastPeriod": "Vs previous period",
  "bidPage.recentHigh": "Recent high",
  "bidPage.recentLow": "Recent low",
  "bidPage.recentPeriods": "Price trend over 6 periods",
  "bidPage.periodLabel": "Period: {value}",
  "bidPage.publishedAt": "Posted",
  "bidPage.deadlineAt": "Bid deadline",
  "bidPage.openedAt": "Bid opening",
  "bidPage.bidCount": "Bidders",
  "bidPage.currency": "Currency",
  "bidPage.referenceUnitPrice": "Reference unit price",
  "bidPage.share": "Share",
  "bidPage.stock": "Stock",
  "bidPage.status": "Status",
  "bidPage.id": "ID",
  "bidPage.unitPrice": "Reference unit price",
  "bidPage.wantBid": "Place a bid",
  "bidPage.unknown": "Unknown",
  "bidPage.companyMissing": "Company not provided",
  "bidPage.statisticsLoadFailed":
    "Couldn't load bid statistics. Please try again later.",
  "bidPage.listLoadFailed": "Couldn't load bids. Please try again later.",
  "bidPage.referencePrice": "Reference price",
  "bidPage.statisticsEmpty": "No bid statistics yet",
  "bidPage.brandPrefix": "Brand: ",
  "bidPage.categoryPrefix": "Category: ",
  "bidPage.technologyPrefix": "Technology: ",
  "bidPage.capacityPrefix": "Capacity: ",
  "bidPage.locationPrefix": "Stock location: ",
  "bidPage.packagingPrefix": "Packaging: ",
  "bidPage.packagePrefix": "Package: ",
  "bidPage.periodPrefix": "Period: ",
  "bidPage.idPrefix": "ID: ",
  "bidPage.deadlinePrefix": "Deadline: ",
  "bidPage.submittedForReview": "Submitted for review",
  "bidPage.lowestQuote": "Lowest bid",
  "bidPage.totalBidQuantity": "Total bid quantity",
  "bidPage.selectPart": "Select all for this part",
  "bidPage.select": "Select",
  "bidPage.rank": "Rank",
  "bidPage.lastBidAt": "Last bid time",
  "bidPage.totalBidAmount": "Total bid amount",
  "bidPage.selectedSummary": "Selected bid summary",
  "bidPage.selected": "Selected",
  "bidPage.usersUnit": " bidders",
  "bidPage.clearSelection": "Clear selection",
  "bidPage.totalQtyEditable": "Total quantity (editable)",
  "bidPage.lowestEditable": "Lowest price (editable)",
  "bidPage.selectedLowest": "Lowest selected bid: ",
  "bidPage.feeMode": "Fee mode",
  "bidPage.external": "External fee",
  "bidPage.feeRateEditable": "Fee rate (editable)",
  "bidPage.selectedAmount": "Selected bid amount: ",
  "bidPage.fee": "Fee: ",
  "bidPage.settlement": "Settlement amount: ",
  "bidPage.updateReview": "Update review data",
  "bidPage.addReview": "Add to review summary",
  "bidPage.confirmScope": "Confirm scope",
  "bidPage.allPeriods": "All periods ({count})",
  "bidPage.periodCount": "{period} ({count})",
  "bidPage.addedReview": "Added to review summary",
  "bidPage.partsUnit": "part numbers across",
  "bidPage.periodsUnit": "periods",
  "bidPage.partsAndPeriods": "{parts} part numbers across {periods} periods",
  "bidPage.confirmAll": "Confirm all",
  "bidPage.confirmPeriod": "Confirm this period",
  "bidPage.loadMore": "Load more...",
  "bidPage.noMore": "No more data",
  "bidPage.selectedRows": "{count} selected",
  "bidPage.rowsUnit": "rows",
  "bidPage.approve": "Approve",
  "bidPage.statisticsLoadError": "Couldn't load bid statistics",
  "bidPage.listLoadError": "Couldn't load bids",
  "bidPage.chooseReviewUsers": "Select bidders to submit for review",
  "bidPage.invalidSettlement": "Enter a valid total quantity and lowest price",
  "bidPage.reviewAddedNotice":
    "Added to review summary. Confirm everything at the bottom of the page.",
  "bidPage.invalidAuditNumber":
    "The review reference is missing. Check the bid review list.",
  "bidPage.createAuditFailed":
    "Couldn't create the bid review. Please try again.",
  "bidPage.approveConfirm": "Approve {count} selected items?",
  "bidPage.approveTitle": "Confirm approval",
  "bidPage.confirmApprove": "Approve",
  "bidPage.cancel": "Cancel",
  "bidPage.approveSuccess": "Approved {count} items",
  "bidPage.deleteConfirm":
    "Delete {count} selected items? This cannot be undone.",
  "bidPage.deleteTitle": "Confirm deletion",
  "bidPage.confirmDelete": "Delete",
  "bidPage.deleteFailed": "Deletion failed",
  "bidPage.deleteSuccess": "Deleted {count} items",
  "bidPage.specMissingFields":
    "This bid has no brand or part number to match with the chip wiki",
  "bidPage.specNotFound": "No matching chip wiki entry",
  "bidPage.specLookupFailed":
    "Couldn't search the chip wiki. Please try again later.",
  "bidPage.noData": "No data",
  "bidPage.copied": "Copied to clipboard",
  "bidPage.copyFailed": "Couldn't copy. Please copy manually.",
  "bidPage.unfavorited": "Removed from favorites",
  "bidPage.favorited": "Saved to favorites and synced to My account",
  "bidPage.loginToBid": "Sign in before bidding",
  "bidPage.loginToPost": "Sign in before posting a bid",
  "bidPage.closedCannotEdit": "This bid has ended and cannot be edited",
  "bidPage.invalidQuote": "Enter a valid bid price",
  "bidPage.invalidQuantity": "Enter a valid quantity no greater than stock",
  "bidPage.submitFailed": "Bid submission failed",
  "bidPage.submitRetry": "Couldn't submit the bid. Please try again later.",
  "bidPage.submitSuccess": "Bid submitted",
  "bidPage.shareCopied": "Share link copied to clipboard",
  "bidPage.dayCountdown": "{days}d {time}",
  "bidPage.locationHongKong": "Hong Kong, China",
  "bidPage.locationMainland": "Mainland China",
  "bidPage.locationBonded": "Bonded zone",
  "bidPage.conditionOriginalFactory": "Factory original",
  "bidPage.conditionOriginalBox": "Original box",
  "bidPage.conditionOriginalGoods": "Original goods",
  "bidPage.conditionOriginalPack": "Original packaging",
  "bidPage.conditionOriginalLabel": "Original label",
  "bidPage.edit": "Edit",
  "bidPage.pendingPublish": "Pending publication",
  "bidPage.changeBid": "Edit bid",
  "bidPage.awaitOpening": "Awaiting bid opening",
});

// 个人竞标
export const personal = Object.freeze({
  "biddingPersonal.followTitle": "My follow-ups",
  "biddingPersonal.followerTitle": "My bid assistant",
  "biddingPersonal.followDescription":
    "View invitees' participation and bid results",
  "biddingPersonal.followerDescription":
    "View your bid assistant and linked bids; participate or revise before the deadline",
  "biddingPersonal.searchFollow": "Search model or brand",
  "biddingPersonal.searchFavorite": "Search part number or brand",
  "biddingPersonal.filterAll": "All",
  "biddingPersonal.filterBidding": "Bidding",
  "biddingPersonal.filterWaiting": "Awaiting opening",
  "biddingPersonal.filterOpened": "Opened",
  "biddingPersonal.stageInvited": "Not yet participating",
  "biddingPersonal.stageBidding": "Bidding",
  "biddingPersonal.stageWaiting": "Awaiting opening",
  "biddingPersonal.stageWon": "Won",
  "biddingPersonal.stageLost": "Lost",
  "biddingPersonal.exclusiveFollower": "Dedicated bid assistant",
  "biddingPersonal.invitedPerson": "Invitee",
  "biddingPersonal.follower": "Bid assistant",
  "biddingPersonal.submittedCount": "Submitted {count} times",
  "biddingPersonal.establishedService": "Bid assistance established",
  "biddingPersonal.relatedBid": "Linked bid {model}",
  "biddingPersonal.viewFollower": "View bid assistant",
  "biddingPersonal.noFollowUsers": "No follow-up users",
  "biddingPersonal.noFollowers": "No bid assistants",
  "biddingPersonal.followUser": "Follow-up user",
  "biddingPersonal.bidModel": "Bid model",
  "biddingPersonal.currentStage": "Current stage",
  "biddingPersonal.submissionCount": "Submissions",
  "biddingPersonal.times": "{count} times",
  "biddingPersonal.updatedAt": "Status updated at",
  "biddingPersonal.followUserDetail": "Follow-up user details",
  "biddingPersonal.followerDetail": "My bid assistant details",
  "biddingPersonal.myFollowUser": "User I follow",
  "biddingPersonal.myFollower": "Bid assistant assigned to me",
  "biddingPersonal.companyMissing": "Company not provided",
  "biddingPersonal.relationshipAt": "Relationship established at",
  "biddingPersonal.serving": "Active",
  "biddingPersonal.bidFlow": "Bid process",
  "biddingPersonal.autoUpdated": "Updated automatically from bid status",
  "biddingPersonal.relationshipEstablished": "Relationship established",
  "biddingPersonal.participated": "Participated in bid",
  "biddingPersonal.waitingOpen": "Awaiting opening",
  "biddingPersonal.relatedBidTitle": "Linked bid",
  "biddingPersonal.viewBid": "View bid",
  "biddingPersonal.brandCategory": "Brand / category",
  "biddingPersonal.requiredQuantity": "Required quantity",
  "biddingPersonal.submissionRecords": "Submission history",
  "biddingPersonal.deadline": "Bid deadline",
  "biddingPersonal.openAt": "Opening time",
  "biddingPersonal.bidActivity": "Bid activity",
  "biddingPersonal.recentUpdate": "Last updated: {time}",
  "biddingPersonal.close": "Close",
  "biddingPersonal.myFavorites": "My favorites",
  "biddingPersonal.supply": "Supply",
  "biddingPersonal.demand": "Demand",
  "biddingPersonal.purchase": "Wanted",
  "biddingPersonal.unfavorite": "Remove from favorites",
  "biddingPersonal.category": "Category",
  "biddingPersonal.condition": "Condition",
  "biddingPersonal.favoriteAt": "Favorited at",
  "biddingPersonal.noFavorites": "No saved supply or demand listings",
  "biddingPersonal.hintInvited":
    "Relationship established; no bid submitted yet",
  "biddingPersonal.hintBidding":
    "Revisions are allowed until the deadline; the latest submission counts",
  "biddingPersonal.hintWaiting": "Deadline passed; awaiting bid opening",
  "biddingPersonal.hintWon": "Bid opened and won",
  "biddingPersonal.hintLost": "Bid opened and lost",
  "biddingPersonal.hintDefault": "View bid status",
  "biddingPersonal.openResult": "Opening result",
  "biddingPersonal.logRelation": "Bid assistance established",
  "biddingPersonal.logRelationDetail":
    "{name} accepted the shared bid invitation",
  "biddingPersonal.logSubmission": "Bid submitted",
  "biddingPersonal.logSubmissionDetail":
    "The invitee has submitted bid information {count} times; revisions are allowed until the deadline",
  "biddingPersonal.logWon": "This bid was won",
  "biddingPersonal.logLost": "This bid was lost",
  "biddingPersonal.customer": "Customer",
});

export const messages = Object.freeze({ ...page, ...personal });
